import React, { useEffect } from 'react';
import '../css/work.css';
import Playground from './Playground';

function Work() {
    useEffect(() => {
        const handleScroll = () => {
            const reveals = document.querySelectorAll(".reveal");
            reveals.forEach((reveal) => {
                const windowHeight = window.innerHeight;
                const elementTop = reveal.getBoundingClientRect().top;
                const elementVisible = 150;

                if (elementTop < windowHeight - elementVisible) {
                    reveal.classList.add("revealed");
                } else {
                    reveal.classList.remove("revealed");
                }
            });
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div id="work">
                <div className="project">
                    <div>
                        <div>
                            <img src="./images/Devhunt1.png" alt="Gaming Deals (2024)" className="reveal" />
                            {/* <img src="./images/Devhunt2.png" alt="Gaming Deals (2024)" className="reveal" /> */}
                        </div>
                        <div>
                            {/* <img src="./images/Devhunt1.png" alt="Gaming Deals (2024)" className="reveal" /> */}
                            <img src="./images/Devhunt2.png" alt="Gaming Deals (2024)" className="reveal" />
                        </div>
                    </div>
                    <div className="reveal">
                        <p style={{ color: "white", fontSize:"15px", fontStyle:"italic", letterSpacing:"2px" }}>
                            <span style={{fontFamily:"serif", fontSize:"24px", marginBottom:"10px"}}>DevHunt - Connecting Talent with Opportunity</span>
                            
                            {/* <br />
                            <b>Project:</b> Web App */}
                            <br />
                            <b>Tools:</b> Django, Python, HTML, Bootstrap and Javascript
                        </p>
                        <p style={{ color: "white", fontSize:"larger", fontStyle:"italic", letterSpacing:"2px" }}>
                            DevHunt is a platform where developers and businesses meet.
                            Whether you're a developer looking to showcase your skills
                            or a business in need of top talent for your projects,
                            DevHunt bridges the gap. Connect, collaborate, and create
                            with ease—your next big opportunity starts here!
                        </p>
                    </div>
                </div>

                <div className="project">
                    <div>
                        <div>
                            <img
                                src="./images/edusite1.png"
                                alt="Coderhouse (2023)"
                                className="reveal"
                            />
                            {/* <img
                                src="./images/Edusite2.png"
                                alt="Coderhouse (2023)"
                                className="reveal"
                            /> */}
                        </div>
                        <div>
                            {/* <img
                                src="./images/Edusite1.png"
                                alt="Coderhouse (2023)"
                                className="reveal"
                            /> */}
                            <img
                                src="./images/Edusite2.png"
                                alt="Coderhouse (2023)"
                                className="reveal"
                            />
                        </div>
                        <div>
                            <img
                                src="./images/Edusite3.png"
                                alt="Coderhouse (2023)"
                                className="reveal"
                            />
                        </div>
                    </div>
                    <div className="reveal">
                        <p style={{ color: "white", fontSize:"15px", fontStyle:"italic", letterSpacing:"2px" }}>
                            <span style={{fontFamily:"serif", fontSize:"24px", marginBottom:"10px"}}>Edusite - Your Gateway to Learning and Teaching</span>
                            {/* {/* <br /> */}
                            <br />
                            {/* <b>Project:</b> Website */}
                            {/* <br /> */}
                            <b>Tools:</b> Django, Python, HTML, Bootstrap and Javascript
                        </p>
                        <p style={{ color: "white", fontSize:"larger", fontStyle:"italic", letterSpacing:"2px" }}>
                        Edusite is a dynamic online platform designed for
                            both students and instructors. It empowers learners
                            to explore a wide range of courses and equips
                            instructors to share their expertise with the world.
                            Whether you're here to gain new skills or teach what
                            you love, Edusite makes learning and teaching easy,
                            accessible, and impactful. Sign up today and take the
                            first step toward your educational goals!
                        </p>
                    </div>
                </div>

                <div className="project">
                    <div>
                        <div>
                            <img
                                src="./images/Frame 19.png"
                                alt="HYPER (2022)"
                                className="reveal"
                            />
                            {/* <img
                                src="./images/Frame 21.png"
                                alt="HYPER (2022)"
                                className="reveal"
                            /> */}
                        </div>
                        <div>
                            <img
                                src="./images/Frame 20.png"
                                alt="HYPER (2022)"
                                className="reveal"
                            />
                            
                        </div>
                        <div>
                            <img
                                src="./images/Frame 21.png"
                                alt="Nicer (2024)"
                                className="reveal"
                            />
                        </div>
                        <div>
                            <img
                                src="./images/Frame 22.png"
                                alt="Nicer (2024)"
                                className="reveal"
                            />
                            {/* <img
                                src="./images/13.png"
                                alt="Nicer (2024)"
                                className="reveal"
                            /> */}
                        </div>
                        <div>
                            <img
                                src="./images/Frame 23.png"
                                alt="Nicer (2024)"
                                className="reveal"
                            />
                            {/* <img
                                src="./images/13.png"
                                alt="Nicer (2024)"
                                className="reveal"
                            /> */}
                        </div>
                        
                    </div>
                    <div className="reveal">
                    <p style={{ color: "white", fontSize:"15px", fontStyle:"italic", letterSpacing:"2px" }}>
                            <span style={{fontFamily:"serif", fontSize:"24px", marginBottom:"10px"}}>Easydeal - Furlenco inspired app.</span>
                            {/* {/* <br /> */}
                            <br />
                            {/* <b>Project:</b> Website */}
                            {/* <br /> */}
                            <b>Tools:</b> Flutter, RestAPIs
                        </p>
                        <p style={{ color: "white", fontSize:"larger", fontStyle:"italic", letterSpacing:"2px" }}>
                        Discover amazing deals on furniture that will
                            transform your home without breaking the bank.
                            Browse a wide selection of stylish and affordable pieces,
                            from cozy sofas and elegant dining sets to comfortable
                            beds and functional home office essentials.
                        </p>
                    </div>
                </div>

                {/* <div className="project">
                    <div>
                        <div>
                            <img
                                src="./images/Frame 21.png"
                                alt="PedidosYa X Wibond Connect (2024)"
                                className="reveal"
                            />
                            <img
                                src="./images/Frame 22.png"
                                alt="PedidosYa X Wibond Connect (2024)"
                                className="reveal"
                            />
                        </div>
                    </div>
                    <div className="reveal">
                        <p style={{ color: "white", fontSize:"larger" }}>
                            <span>Easydeal:</span>
                            <br />
                            <br />
                            <b>Project:</b> Application
                            <br />
                            <b>Role:</b> Home Essential
                        </p>
                        <p style={{ color: "white", fontSize:"larger" }}>
                            Discover amazing deals on furniture that will
                            transform your home without breaking the bank.
                            Browse a wide selection of stylish and affordable pieces,
                            from cozy sofas and elegant dining sets to comfortable
                            beds and functional home office essentials. Furlenco inspired app.
                        </p>
                    </div>
                </div> */}

            </div>

            <Playground />
        </>
    )
}

export default Work